import styled from 'styled-components';

export const IconContainer = styled.div<{
  $size: number;
  $color?: string;
  $opacity?: number;
  $filter?: string;
}>`
  display: inline-flex;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  color: ${({ $color }) => $color || 'inherit'};
  ${({ $filter }) =>
    $filter !== undefined && `filter: brightness(0) ${$filter}`};
  ${({ $opacity }) => $opacity !== undefined && `opacity: ${$opacity}`};

  flex-shrink: 0;
  pointer-events: none;
  vertical-align: middle;

  /* This is a fix for iOS Safari 15.3 */
  svg {
    height: 100%;
    width: 100%;
  }
`;
